module.exports = __webpack_public_path__ + "img/children-4.d4b931e6.jpg";